import { render, staticRenderFns } from "./CommercialConfig.vue?vue&type=template&id=4c263b66"
import script from "./CommercialConfig.vue?vue&type=script&lang=js"
export * from "./CommercialConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports